import simpleLayout1 from './simple-layout1'
import simpleLayout2 from './simple-layout2'
import baseline from './baseline'

export default [
  simpleLayout1,
  simpleLayout2,
  baseline
]
